import {
    boolean,
    index,
    integer,
    snakeCase,
    text,
    varchar,
} from 'drizzle-orm/pg-core'
import { id, timestamps } from '../utils/columns.helpers'
import { benefitsTable } from './benefits.table'

export const benefitImagesTable = snakeCase.table(
    'benefit_images',
    {
        id: id('bnfi'),
        benefitId: text()
            .notNull()
            .references(() => benefitsTable.id, {
                onDelete: 'cascade',
                onUpdate: 'cascade',
            }),
        url: text().notNull(),
        fileKey: text().notNull(),
        altText: varchar({ length: 255 }).default(''),
        isPrimary: boolean().notNull().default(false),
        displayOrder: integer().notNull().default(0),
        ...timestamps,
    },
    (table) => [
        index('benefit_images_benefit_idx').on(table.benefitId),
        index('benefit_images_benefit_primary_idx').on(
            table.benefitId,
            table.isPrimary,
        ),
    ],
)
